import * as CONST from 'Reducers/Ambassador/const'

/**
 * Get ambassadors by city id
 * @returns Object
 */
export function getAmbassadorsByCityId(clientId) {
  return {
    type: CONST.GET_AMBASSADORS_BY_CITY_ID,
    clientId,
  }
}
/**
 * Resset user data
 * @returns Object
 */
export function ressetAmbassadorData() {
  return {
    type: CONST.RESSET_AMBASSADOR_DATA,
  }
}
/**
 * Get ambassadors by city id (Using GraphQL query)
 * @returns Object
 */
export function getAmbassadorsByCityIdGraphQL(cityId) {
  return {
    type: CONST.GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL,
    payload: { cityId },
  }
}

/**
 * Upload ambassadors document in parallel
 * @returns Object
 */
export function uploadAmbassadorDocument(ambassadorId, payload, callbacks) {
  return {
    type: CONST.UPLOAD_AMBASSADOR_DOCUMENT,
    ambassadorId,
    payload,
    callbacks,
  }
}
/**
 * Get ambassador by id
 * @returns Object
 */
export function getAmbassadorById(ambassadorId) {
  return {
    type: CONST.GET_AMBASSADOR_BY_ID,
    ambassadorId,
  }
}
/**
 * Get ambassador by id (Using GraphQL query)
 * @returns Object
 */
export function getAmbassadorByIdGraphQL(id) {
  return {
    type: CONST.GET_AMBASSADOR_BY_ID_GRAPH_QL,
    payload: { id },
  }
}

/**
 * Update ambassador by id
 *
 * @param ambassadorId
 * @param payload
 * @param callbacks
 * @returns {{type, ambassadorId: *, payload: *, callbacks: *}}
 */
export function updateAmbassadorById(ambassadorId, payload, callbacks) {
  return {
    type: CONST.UPDATE_AMBASSADOR_BY_ID,
    ambassadorId,
    callbacks,
    payload,
  }
}

/**
 * Get ambassador documents by id
 * @returns Object
 */
export function getAmbassadorDocumentsById(ambassadorId) {
  return {
    type: CONST.GET_AMBASSADOR_DOCUMENTS_BY_ID,
    ambassadorId,
  }
}

/**
 * Create ambassador documents by id
 * @returns Object
 */
export function createAmbassadorDocumentsById(
  ambassadorId,
  payload,
  callbacks,
) {
  return {
    type: CONST.CREATE_AMBASSADOR_DOCUMENTS_BY_ID,
    ambassadorId,
    payload,
    callbacks,
  }
}

/**
 * Set inventory by client id sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export function setInventoryByClientIdSortBy(sortBy) {
  return {
    type: CONST.SET_INVENTORY_BY_CLIENT_ID_SORT_BY,
    inventoryByClientIdSortBy: sortBy,
  }
}

/**
 * Set inventories by client id
 *
 * @param {int} clientId
 * @returns {{type, payload: {clientId: int}}}
 */
export function setInventoryByClientIdFilter(clientId) {
  return {
    type: CONST.SET_INVENTORY_BY_CLIENT_ID,
    payload: {
      clientId: clientId,
    },
  }
}

/**
 * Set activity filter status
 *
 * @param {string} status
 * @returns {{type, payload: {status: string}}}
 */
export function setActivityFilterStatus(status) {
  return {
    type: CONST.SET_ACTIVITY_FILTER_STATUS,
    payload: {
      status: status,
    },
  }
}

/**
 * Set activities
 *
 * @param {int} ambassadorId
 * @returns object
 */
export function getAmbassadorActivitiesById(ambassadorId) {
  return {
    type: CONST.GET_AMBASSADOR_ACTIVITIES,
    ambassadorId,
  }
}

/**
 * Set activities sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export function setActivitiesSortBy(sortBy) {
  return {
    type: CONST.SET_ACTIVITIES_SORT_BY,
    activitiesSortBy: sortBy,
  }
}

/**
 * Set ambassador status
 *
 * @param ambassadorId
 * @param status
 * @returns {{type, sortBy: *}}
 */
export function setAmbassadorStatus(ambassadorId, status) {
  return {
    type: CONST.SET_AMBASSADOR_STATUS,
    ambassadorStatus: status,
    ambassadorId: ambassadorId,
  }
}

/**
 * Update ambassador by id
 *
 * @param ambassadorId
 * @param payload
 * @param callbacks
 * @returns {{type, ambassadorId: *, payload: *, callbacks: *}}
 */
export function updateAmbassadorByIdGraphQL(ambassadorId, payload, callbacks) {
  return {
    type: CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL,
    ambassadorId,
    callbacks,
    payload,
  }
}
